var map = {
  "./code-example/element.js": [
    "./components/code-example/element.js",
    [
      "vendors-node_modules_lit_directives_ref_js",
      "node_modules_css-loader_dist_cjs_js_ruleSet_1_rules_4_use_1_build_loaders_fix-light-dark_js_n-8c2ddd",
      "node_modules_css-loader_dist_cjs_js_ruleSet_1_rules_4_use_1_build_loaders_fix-light-dark_js_n-6341b1",
      "components_copy-button_element_js",
      "components_code-example_element_js"
    ]
  ],
  "./dropdown/element.js": [
    "./components/dropdown/element.js",
    [
      "components_dropdown_element_js"
    ]
  ],
  "./live-sample-result/element.js": [
    "./components/live-sample-result/element.js",
    [
      "vendors-node_modules_lit_directives_ref_js",
      "vendors-node_modules_lit_directives_style-map_js",
      "vendors-node_modules_lit_directives_keyed_js",
      "node_modules_css-loader_dist_cjs_js_ruleSet_1_rules_4_use_1_build_loaders_fix-light-dark_js_n-8c2ddd",
      "components_color-theme_controller_js",
      "components_play-runner_element_js",
      "node_modules_css-loader_dist_cjs_js_ruleSet_1_rules_4_use_1_build_loaders_fix-light-dark_js_n-6341b1",
      "components_live-sample-result_element_js"
    ]
  ],
  "./observatory-tests-and-scores/element.js": [
    "./components/observatory-tests-and-scores/element.js",
    [
      "node_modules_css-loader_dist_cjs_js_ruleSet_1_rules_4_use_1_build_loaders_fix-light-dark_js_n-8c2ddd",
      "components_observatory-tests-and-scores_element_js"
    ]
  ],
  "./play-runner/element.js": [
    "./components/play-runner/element.js",
    [
      "vendors-node_modules_lit_directives_ref_js",
      "vendors-node_modules_lit_directives_keyed_js",
      "components_color-theme_controller_js",
      "components_play-runner_element_js"
    ]
  ],
  "./search-button/element.js": [
    "./components/search-button/element.js",
    [
      "components_search-button_element_js"
    ]
  ],
  "./survey/element.js": [
    "./components/survey/element.js",
    [
      "vendors-node_modules_lit_directives_ref_js",
      "node_modules_css-loader_dist_cjs_js_ruleSet_1_rules_4_use_1_build_loaders_fix-light-dark_js_n-758fb0",
      "components_survey_element_js"
    ]
  ],
  "./ix-tab-wrapper/element.js": [
    "./components/ix-tab-wrapper/element.js",
    [
      "components_ix-tab-wrapper_element_js"
    ]
  ],
  "./placement-sidebar/element.js": [
    "./components/placement-sidebar/element.js",
    [
      "vendors-node_modules_lit_directives_ref_js",
      "vendors-node_modules_lit_directives_style-map_js",
      "components_placement-no_element_js",
      "components_placement-note_element_js",
      "components_placement_mixin_js",
      "components_placement-sidebar_element_js"
    ]
  ],
  "./placement-hp-main/element.js": [
    "./components/placement-hp-main/element.js",
    [
      "vendors-node_modules_lit_directives_ref_js",
      "vendors-node_modules_lit_directives_style-map_js",
      "components_placement-no_element_js",
      "components_placement-note_element_js",
      "components_placement_mixin_js",
      "components_placement-hp-main_element_js"
    ]
  ],
  "./record-visit/element.js": [
    "./components/record-visit/element.js",
    [
      "components_recently-visited_index_js",
      "components_record-visit_element_js"
    ]
  ],
  "./toggle-sidebar/element.js": [
    "./components/toggle-sidebar/element.js",
    [
      "components_toggle-sidebar_element_js"
    ]
  ],
  "./user-menu/element.js": [
    "./components/user-menu/element.js",
    [
      "node_modules_css-loader_dist_cjs_js_ruleSet_1_rules_4_use_1_build_loaders_fix-light-dark_js_n-8c2ddd",
      "components_dropdown_element_js",
      "node_modules_css-loader_dist_cjs_js_ruleSet_1_rules_4_use_1_build_loaders_fix-light-dark_js_n-758fb0",
      "components_user-menu_element_js"
    ]
  ],
  "./interactive-example/element.js": [
    "./components/interactive-example/element.js",
    [
      "vendors-node_modules_lit_directives_ref_js",
      "vendors-node_modules_lit_directives_keyed_js",
      "vendors-node_modules_codemirror_dist_index_js",
      "vendors-node_modules_codemirror_lang-html_dist_index_js-node_modules_codemirror_lang-wast_dis-372ed0",
      "vendors-node_modules_codemirror_search_dist_index_js-node_modules_codemirror_theme-one-dark_d-10f542",
      "vendors-node_modules_codemirror_view_dist_index_js",
      "vendors-node_modules_lezer_css_dist_index_js-node_modules_lezer_html_dist_index_js-node_modul-567998",
      "vendors-node_modules_marijn_find-cluster-break_src_index_js-node_modules_style-mod_src_style-mod_js",
      "vendors-node_modules_w3c-keyname_index_js",
      "vendors-node_modules_he_he_js",
      "node_modules_css-loader_dist_cjs_js_ruleSet_1_rules_4_use_1_build_loaders_fix-light-dark_js_n-8c2ddd",
      "components_color-theme_controller_js",
      "components_play-runner_element_js",
      "components_play-console_element_js",
      "components_play-editor_element_js",
      "node_modules_css-loader_dist_cjs_js_ruleSet_1_rules_4_use_1_build_loaders_fix-light-dark_js_n-6341b1",
      "components_play-controller_element_js",
      "components_copy-button_element_js",
      "components_ix-tab-panel_element_js",
      "components_code-example_element_js",
      "components_ix-tab_element_js",
      "components_ix-tab-wrapper_element_js",
      "components_interactive-example_element_js"
    ]
  ],
  "./copy-button/element.js": [
    "./components/copy-button/element.js",
    [
      "components_copy-button_element_js"
    ]
  ],
  "./observatory-comparison-table/element.js": [
    "./components/observatory-comparison-table/element.js",
    [
      "node_modules_css-loader_dist_cjs_js_ruleSet_1_rules_4_use_1_build_loaders_fix-light-dark_js_n-8c2ddd",
      "node_modules_css-loader_dist_cjs_js_ruleSet_1_rules_4_use_1_build_loaders_fix-light-dark_js_n-a4415b",
      "components_observatory_utils_js",
      "components_observatory-comparison-table_element_js"
    ]
  ],
  "./sidebar-filter/element.js": [
    "./components/sidebar-filter/element.js",
    [
      "node_modules_css-loader_dist_cjs_js_ruleSet_1_rules_4_use_1_build_loaders_fix-light-dark_js_n-8c2ddd",
      "node_modules_css-loader_dist_cjs_js_ruleSet_1_rules_4_use_1_build_loaders_fix-light-dark_js_n-a4415b",
      "components_sidebar-filter_element_js"
    ]
  ],
  "./issues-table/element.js": [
    "./components/issues-table/element.js",
    [
      "components_issues-table_element_js"
    ]
  ],
  "./scrim-inline/element.js": [
    "./components/scrim-inline/element.js",
    [
      "vendors-node_modules_lit_directives_ref_js",
      "vendors-node_modules_lit_directives_style-map_js",
      "node_modules_css-loader_dist_cjs_js_ruleSet_1_rules_4_use_1_build_loaders_fix-light-dark_js_n-a4415b",
      "components_scrim-inline_element_js"
    ]
  ],
  "./switch/element.js": [
    "./components/switch/element.js",
    [
      "components_switch_element_js"
    ]
  ],
  "./collection-save-button/element.js": [
    "./components/collection-save-button/element.js",
    [
      "components_modal_element_js",
      "components_collection-save-button_element_js"
    ]
  ],
  "./contributor-list/element.js": [
    "./components/contributor-list/element.js",
    [
      "components_contributor-list_element_js"
    ]
  ],
  "./button/element.js": [
    "./components/button/element.js",
    []
  ],
  "./homepage-search/element.js": [
    "./components/homepage-search/element.js",
    [
      "node_modules_css-loader_dist_cjs_js_ruleSet_1_rules_4_use_1_build_loaders_fix-light-dark_js_n-8c2ddd",
      "components_homepage-search_element_js"
    ]
  ],
  "./modal/element.js": [
    "./components/modal/element.js",
    [
      "components_modal_element_js"
    ]
  ],
  "./color-theme/element.js": [
    "./components/color-theme/element.js",
    [
      "components_dropdown_element_js",
      "components_color-theme_element_js"
    ]
  ],
  "./about-team-member/element.js": [
    "./components/about-team-member/element.js",
    [
      "components_about-team-member_element_js"
    ]
  ],
  "./content-feedback/element.js": [
    "./components/content-feedback/element.js",
    [
      "components_content-feedback_element_js"
    ]
  ],
  "./play-console/element.js": [
    "./components/play-console/element.js",
    [
      "components_play-console_element_js"
    ]
  ],
  "./ix-tab/element.js": [
    "./components/ix-tab/element.js",
    [
      "components_ix-tab-panel_element_js",
      "components_ix-tab_element_js"
    ]
  ],
  "./observatory-header-link/element.js": [
    "./components/observatory-header-link/element.js",
    [
      "node_modules_css-loader_dist_cjs_js_ruleSet_1_rules_4_use_1_build_loaders_fix-light-dark_js_n-8c2ddd",
      "components_observatory_utils_js",
      "components_observatory-header-link_element_js"
    ]
  ],
  "./curriculum-tabs/element.js": [
    "./components/curriculum-tabs/element.js",
    [
      "components_curriculum-tabs_element_js"
    ]
  ],
  "./placement-bottom/element.js": [
    "./components/placement-bottom/element.js",
    [
      "vendors-node_modules_lit_directives_ref_js",
      "vendors-node_modules_lit_directives_style-map_js",
      "components_placement-no_element_js",
      "components_placement-note_element_js",
      "components_placement_mixin_js",
      "components_placement-bottom_element_js"
    ]
  ],
  "./image-history/element.js": [
    "./components/image-history/element.js",
    [
      "components_image-history_element_js"
    ]
  ],
  "./not-found/element.js": [
    "./components/not-found/element.js",
    [
      "node_modules_css-loader_dist_cjs_js_ruleSet_1_rules_4_use_1_build_loaders_fix-light-dark_js_n-8c2ddd",
      "components_not-found_element_js"
    ]
  ],
  "./placement-note/element.js": [
    "./components/placement-note/element.js",
    [
      "components_placement-note_element_js"
    ]
  ],
  "./compat-table-lazy/element.js": [
    "./components/compat-table-lazy/element.js",
    [
      "vendors-node_modules_lit_directives_ref_js",
      "node_modules_css-loader_dist_cjs_js_ruleSet_1_rules_4_use_1_build_loaders_fix-light-dark_js_n-8c2ddd",
      "node_modules_css-loader_dist_cjs_js_ruleSet_1_rules_4_use_1_build_loaders_fix-light-dark_js_n-a4415b",
      "node_modules_css-loader_dist_cjs_js_ruleSet_1_rules_4_use_1_build_loaders_fix-light-dark_js_n-758fb0",
      "components_compat-table_element_js",
      "components_compat-table-lazy_element_js"
    ]
  ],
  "./site-search/element.js": [
    "./components/site-search/element.js",
    [
      "node_modules_css-loader_dist_cjs_js_ruleSet_1_rules_4_use_1_build_loaders_fix-light-dark_js_n-8c2ddd",
      "components_site-search_element_js"
    ]
  ],
  "./placement-no/element.js": [
    "./components/placement-no/element.js",
    [
      "components_placement-no_element_js"
    ]
  ],
  "./play-controller/element.js": [
    "./components/play-controller/element.js",
    [
      "components_play-controller_element_js"
    ]
  ],
  "./placement-top/element.js": [
    "./components/placement-top/element.js",
    [
      "vendors-node_modules_lit_directives_ref_js",
      "vendors-node_modules_lit_directives_style-map_js",
      "components_placement-no_element_js",
      "components_placement-note_element_js",
      "components_placement_mixin_js",
      "components_placement-top_element_js"
    ]
  ],
  "./observatory-form/element.js": [
    "./components/observatory-form/element.js",
    [
      "vendors-node_modules_lit_directives_ref_js",
      "node_modules_css-loader_dist_cjs_js_ruleSet_1_rules_4_use_1_build_loaders_fix-light-dark_js_n-8c2ddd",
      "node_modules_css-loader_dist_cjs_js_ruleSet_1_rules_4_use_1_build_loaders_fix-light-dark_js_n-a4415b",
      "components_progress-bar_element_js",
      "components_observatory-form_element_js"
    ]
  ],
  "./observatory-results/element.js": [
    "./components/observatory-results/element.js",
    [
      "node_modules_css-loader_dist_cjs_js_ruleSet_1_rules_4_use_1_build_loaders_fix-light-dark_js_n-8c2ddd",
      "node_modules_css-loader_dist_cjs_js_ruleSet_1_rules_4_use_1_build_loaders_fix-light-dark_js_n-a4415b",
      "components_dropdown_element_js",
      "components_observatory_utils_js",
      "components_progress-bar_element_js",
      "components_observatory-comparison-table_element_js",
      "components_observatory-header-link_element_js",
      "components_observatory-rescan-button_element_js",
      "components_observatory-human-duration_element_js",
      "components_observatory-results_element_js"
    ]
  ],
  "./about-tabs/element.js": [
    "./components/about-tabs/element.js",
    [
      "node_modules_css-loader_dist_cjs_js_ruleSet_1_rules_4_use_1_build_loaders_fix-light-dark_js_n-8c2ddd",
      "components_about-tabs_element_js"
    ]
  ],
  "./observatory-human-duration/element.js": [
    "./components/observatory-human-duration/element.js",
    [
      "node_modules_css-loader_dist_cjs_js_ruleSet_1_rules_4_use_1_build_loaders_fix-light-dark_js_n-8c2ddd",
      "components_observatory_utils_js",
      "components_observatory-human-duration_element_js"
    ]
  ],
  "./playground/element.js": [
    "./components/playground/element.js",
    [
      "vendors-node_modules_lit_directives_ref_js",
      "vendors-node_modules_lit_directives_keyed_js",
      "vendors-node_modules_codemirror_dist_index_js",
      "vendors-node_modules_codemirror_lang-html_dist_index_js-node_modules_codemirror_lang-wast_dis-372ed0",
      "vendors-node_modules_codemirror_search_dist_index_js-node_modules_codemirror_theme-one-dark_d-10f542",
      "vendors-node_modules_codemirror_view_dist_index_js",
      "vendors-node_modules_lezer_css_dist_index_js-node_modules_lezer_html_dist_index_js-node_modul-567998",
      "vendors-node_modules_marijn_find-cluster-break_src_index_js-node_modules_style-mod_src_style-mod_js",
      "vendors-node_modules_w3c-keyname_index_js",
      "node_modules_css-loader_dist_cjs_js_ruleSet_1_rules_4_use_1_build_loaders_fix-light-dark_js_n-8c2ddd",
      "components_color-theme_controller_js",
      "components_play-runner_element_js",
      "components_play-console_element_js",
      "components_play-editor_element_js",
      "components_play-controller_element_js",
      "components_modal_element_js",
      "components_playground_element_js"
    ]
  ],
  "./ix-tab-panel/element.js": [
    "./components/ix-tab-panel/element.js",
    [
      "components_ix-tab-panel_element_js"
    ]
  ],
  "./play-editor/element.js": [
    "./components/play-editor/element.js",
    [
      "vendors-node_modules_codemirror_dist_index_js",
      "vendors-node_modules_codemirror_lang-html_dist_index_js-node_modules_codemirror_lang-wast_dis-372ed0",
      "vendors-node_modules_codemirror_search_dist_index_js-node_modules_codemirror_theme-one-dark_d-10f542",
      "vendors-node_modules_codemirror_view_dist_index_js",
      "vendors-node_modules_lezer_css_dist_index_js-node_modules_lezer_html_dist_index_js-node_modul-567998",
      "vendors-node_modules_marijn_find-cluster-break_src_index_js-node_modules_style-mod_src_style-mod_js",
      "vendors-node_modules_w3c-keyname_index_js",
      "components_color-theme_controller_js",
      "components_play-editor_element_js"
    ]
  ],
  "./themed-image/element.js": [
    "./components/themed-image/element.js",
    [
      "components_themed-image_element_js"
    ]
  ],
  "./writer-open-editor/element.js": [
    "./components/writer-open-editor/element.js",
    [
      "components_writer-open-editor_element_js"
    ]
  ],
  "./progress-bar/element.js": [
    "./components/progress-bar/element.js",
    [
      "components_progress-bar_element_js"
    ]
  ],
  "./compat-table/element.js": [
    "./components/compat-table/element.js",
    [
      "vendors-node_modules_lit_directives_ref_js",
      "node_modules_css-loader_dist_cjs_js_ruleSet_1_rules_4_use_1_build_loaders_fix-light-dark_js_n-a4415b",
      "node_modules_css-loader_dist_cjs_js_ruleSet_1_rules_4_use_1_build_loaders_fix-light-dark_js_n-758fb0",
      "components_compat-table_element_js"
    ]
  ],
  "./login-button/element.js": [
    "./components/login-button/element.js",
    [
      "components_login-button_element_js"
    ]
  ],
  "./observatory-rescan-button/element.js": [
    "./components/observatory-rescan-button/element.js",
    [
      "node_modules_css-loader_dist_cjs_js_ruleSet_1_rules_4_use_1_build_loaders_fix-light-dark_js_n-8c2ddd",
      "components_observatory-rescan-button_element_js"
    ]
  ],
  "./recently-visited/element.js": [
    "./components/recently-visited/element.js",
    [
      "node_modules_css-loader_dist_cjs_js_ruleSet_1_rules_4_use_1_build_loaders_fix-light-dark_js_n-8c2ddd",
      "components_recently-visited_index_js",
      "components_recently-visited_element_js"
    ]
  ],
  "./language-always-redirect-button/element.js": [
    "./components/language-always-redirect-button/element.js",
    [
      "components_preferred-locale_utils_js",
      "components_language-always-redirect-button_element_js"
    ]
  ],
  "./language-switcher/element.js": [
    "./components/language-switcher/element.js",
    [
      "node_modules_css-loader_dist_cjs_js_ruleSet_1_rules_4_use_1_build_loaders_fix-light-dark_js_n-8c2ddd",
      "components_dropdown_element_js",
      "components_switch_element_js",
      "components_preferred-locale_utils_js",
      "components_language-switcher_element_js"
    ]
  ],
  "./search-modal/element.js": [
    "./components/search-modal/element.js",
    []
  ],
  "./writer-reload/element.js": [
    "./components/writer-reload/element.js",
    [
      "components_writer-reload_element_js"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids[1].map(function(chunkId) { return __webpack_require__.e(chunkId); })).then(() => (__webpack_require__(id)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "./components lazy recursive ^\\.\\/.*\\/element\\.js$";
module.exports = __rspack_async_context;
